<template>
  <div class="server-config-tab">
    <div class="server-config-tab__card">
      <div class="server-config-tab__card-head"><h4>Basics</h4><span class="server-config-tab__note">Read-only for now</span></div>
      <dl class="server-config-tab__list">
        <div class="server-config-tab__row"><dt>Hostname</dt><dd class="server-config-tab__mono">{{ server.hostname }}</dd></div>
        <div class="server-config-tab__row"><dt>Display name</dt><dd>{{ server.display_name || '—' }}</dd></div>
        <div class="server-config-tab__row"><dt>IP addresses</dt><dd>
          <div v-for="ip in ips" :key="ip.address" class="server-config-tab__mono">{{ ip.label }}: {{ ip.address }}</div>
          <span v-if="!ips.length">—</span>
        </dd></div>
        <div class="server-config-tab__row"><dt>Agent version</dt><dd class="server-config-tab__mono">{{ server.luna_version || '—' }}</dd></div>
        <div class="server-config-tab__row"><dt>Enrolled</dt><dd>{{ server.enrolled_at ? formatEpoch(server.enrolled_at) : '—' }}</dd></div>
        <div class="server-config-tab__row"><dt>Last heartbeat</dt><dd>{{ server.last_heartbeat_at ? formatEpoch(server.last_heartbeat_at) : '—' }}</dd></div>
        <div class="server-config-tab__row"><dt>Environment</dt><dd>{{ taxonomyLabel('environment', server.tags.environment) || '—' }}</dd></div>
        <div class="server-config-tab__row"><dt>Provider</dt><dd>{{ taxonomyLabel('provider', server.tags.provider) || '—' }}</dd></div>
        <div class="server-config-tab__row"><dt>Server role</dt><dd>
          <span v-for="role in server.tags.server_role" :key="role" class="server-config-tab__pill">{{ taxonomyLabel('server_role', role) }}</span>
          <span v-if="!server.tags.server_role || !server.tags.server_role.length">—</span>
        </dd></div>
      </dl>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { taxonomyLabel, formatEpoch, parseIps } from '@root/services/serverFormat';

const props = defineProps({
  server: {
    type: Object,
    required: true,
  },
});

const ips = computed(() => parseIps(props.server));
</script>

<style lang="scss">
.server-config-tab {
  &__card {
    background: var(--theme-bg-card);
    border: 1px solid var(--theme-border);
    border-radius: var(--theme-radius-lg, 10px);
    box-shadow: var(--theme-shadow-card);
    overflow: hidden;
  }

  &__card-head {
    padding: 14px 18px;
    border-bottom: 1px solid var(--theme-border-soft);
    display: flex;
    justify-content: space-between;
    align-items: center;

    h4 {
      margin: 0;
      font-size: 13.5px;
      font-weight: 600;
    }
  }

  &__note {
    font-size: 11px;
    color: var(--theme-text-tertiary);
  }

  &__list {
    margin: 0;
  }

  &__row {
    display: grid;
    grid-template-columns: 160px 1fr;
    padding: 10px 18px;
    border-top: 1px solid var(--theme-border-soft);
    font-size: 12.5px;

    &:first-child {
      border-top: none;
    }

    dt {
      color: var(--theme-text-tertiary);
      font-weight: 600;
    }

    dd {
      margin: 0;
    }
  }

  &__mono {
    font-family: var(--theme-font-mono);
  }

  &__pill {
    display: inline-block;
    font-size: 10px;
    font-weight: 700;
    padding: 2.5px 8px;
    border-radius: 3px;
    background: var(--theme-accent-light);
    color: var(--theme-accent-dark);
    margin-right: 4px;
  }
}
</style>
